<template>
  <div class="block">
    <div class="block__item block__intro">
      <div class="block__intro-item">
        <h1>Опубликуйте чемпионат</h1>
      </div>
      <div class="block__intro-item">
        <div class="text-md">
          После публикации чемпионат станет виден на&nbsp;странице клуба, а&nbsp;члены клуба автоматически станут участниками чемпионата.
        </div>
      </div>
    </div>
    <div class="block__item">
      <div class="block__body-item">
        <div class="loader m-0" v-show="!ready"></div>
        <champ-card
          v-if="champ"
          v-show="ready"
          :clubId="id"
          :bordered="true"
          :champ="champ"
          :internal="true"
          :hideStatus="true"
          :hideMember="true"
        >
        </champ-card>
      </div>
      <div class="block__body-item">
        <div class="divider"></div>
      </div>
      <div class="block__body-item">
        <div class="grid grid_v-center grid_v-margins">
          <div class="grid__col grid__col_auto mr-auto">
            <button
              class="action color-muted"
              type="button"
              @click="$emit('prev')"
            >
              <span class="action__container">
                 <span class="action__icon">
                   <icon icon-name='left'></icon>
                 </span>
                <span class="action__text">Назад</span>
              </span>
            </button>
          </div>
          <div class="grid__col grid__col_auto" v-show="ready">
            <button
              class="button button_primary button_lg"
              :class="{'button_loading': isSending}"
              :disabled="isSending"
              @click.prevent="submit"
            >
              <span class="button__text">Опубликовать</span>
              <span class="button__icon button__loading">
                <icon icon-name='loading'></icon>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import champsService from '@/services/champsService'
import ChampCard from '@/components/ChampCard.vue'

export default {
  name: 'ChampPublish',
  components: {
    ChampCard
  },
  props: {
    champ: Object
  },
  data () {
    return {
      id: null,
      clubCode: null,
      ready: false,
      data: null,
      isSending: false
    }
  },
  methods: {
    ...mapActions('alerts', ['addSomethingWrongAlert']),
    ...mapActions('champs', ['triggerChampsUpdate']),
    submit () {
      this.isSending = true
      champsService.publish({ champId: this.id })
        .then((res) => {
          const d = res.data
          if (d.Success) {
            this.$router.replace({
              name: 'ManageChamps'
            })
            this.triggerChampsUpdate(true)
          } else {
            this.addSomethingWrongAlert()
          }
          this.isSending = false
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.id = this.$route.params.champ
    this.ready = true
  }
}
</script>
